import  React,{Component} from 'react';
import axios from 'axios'; 
import Serverurl from './Apiurl';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Button, Collapse, Alert, IconButton } from '@mui/material';
import Teacherclasswisecomparisionreport from "./Teacherclasswisecomparisionreport";
import SearchIcon from '@mui/icons-material/Search';

import CloseIcon from '@mui/icons-material/Close';
export default  class TopperLists extends Component{ 

	constructor(props){
	super(props)
		this.state={
			ToppersData:[],Yeararr:[],yearid:0,branchid:0,Branchdata:[],errormessage:'',errortype:'error',erropen:false,Batcharr:[],Classarr:[],classid:'',batchid:'',
			
		}
		
		
		
	}
	
	componentDidMount() {
	
	document.title = "MM Coching Center - Topper List";
	
	 this.ClassBind();
	 if(localStorage.getItem("MMCrole")==="1"){
this.BranchBind();

	 }
		
	}
	
myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
 	   this.setState({[nam]: val},()=>{
		 
		   if (nam === 'branchid' ) {
		   
		    this.BatchBind();
		   
	   }
		   
	   }) 
 
}
BranchBind()
{
	axios.get(Serverurl+'ajaxbranch.php?action=getall')
       .then(resp => { 		
			if(resp.data.length>0){
				let strbrid=resp.data[0].br_id
				this.setState({
						Branchdata:resp.data},()=>{
							
						 let branchFromApi = this.state.Branchdata.map(row => {
                          
          return {value: row.br_id, display:row.br_title}
        });	
		 this.setState({branchid:strbrid,
          Branchdata: [{value: '0', display: 'Select Branch'}].concat(branchFromApi)
        });
							
						}) 
			
	 }
	 
	 
	   }) 

}

	 ClassBind()
{
	axios.get(Serverurl+'ajaxtrustandclass.php?action=getall&tc_type=2')
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({
						Classarr:resp.data	
							}) 
			}
		
	   }) .then(data => {
        let classFromApi = this.state.Classarr.map(row => {
                          
          return {value: row.tc_id, display:row.tc_title}
        });
      
		
        this.setState({
          Classarr: [{value: '0', display: 'Select Class'}].concat(classFromApi)
        });
      })

} 



BatchBind()
{let strbranch=localStorage.getItem("MMCbranchid");
		if(localStorage.getItem("MMCrole")==="1")
		{
			strbranch=this.state.branchid;
		}
	axios.get(Serverurl+'ajaxbatch.php?action=list&bc_class_id='+this.state.classid+'&bc_br_id='+strbranch)
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({
						Batcharr:resp.data	
							}) 
			}else{
				
				this.setState({
						Batcharr:[]	
							}) 
			}

	   }).then(data => {
        let batchFromApi = this.state.Batcharr.map(row => {
                          
          return {value: row.bc_id, display:row.bc_title}
        });
      
		
        this.setState({
          Batcharr: [{value: '0', display: 'Select Batch'}].concat(batchFromApi)
        });
      })

}
GetTopperlist(){

let strbranch=localStorage.getItem("MMCbranchid");
		if(localStorage.getItem("MMCrole")==="1")
		{
			strbranch=this.state.branchid;
		}
  axios.get(
    Serverurl + 'ajaxtest.php?action=gettopperlist&year='+localStorage.getItem("MMCyearid")+'&sa_br_id='+strbranch+'&batchid='+this.state.batchid+'&classid='+this.state.classid)
  .then(resp => {  

    
		
			this.setState({  
			  ToppersData: resp.data,  
			
			});
     
	
    });

}



  myChangeHandler = (event) => {
	
	  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  
 
 
  this.setState({[nam]: val}, () => {
  

	
			 if(nam==="classid")
	   {
		   this.BatchBind();
			 
 
	   }  
		  
}); 
}


handleClickSearch = () => {
	
	this.GetTopperlist()
	
	
}

	render(){
		
	
		
		return(
		  <React.Fragment>
   
<div className="containermain">
<div className="boxheading">
				  <div className="contntpad">
				  
				  <Collapse in={this.state.erropen}>
              <Alert
                severity={this.state.errortype}
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={this.handleErrorclose}
                  >                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
              >
                {this.state.errormessage}
              </Alert>
            </Collapse>
				  
				  
<h2>Toppers List</h2>
</div>
</div>


<div className="searchmaster">

<ul>
{localStorage.getItem("MMCrole")==="1" &&(
<li>
<p>Branch</p><p> <FormControl  className="stadrp">
          <Select
         native  fullWidth
		 
		 
		 variant="outlined"
            margin="normal"
		 
          onChange={this.myChangeHandler}
          id="branchid"
		   value={this.state.branchid}
		  name="branchid"
		
		
        >
		{this.state.Branchdata.map(brrows => (
            <option  
            
              value={brrows.value}
            >
              {brrows.display}
            </option  >
          ))}
		
        </Select>
       </FormControl>
		
			</p>
</li>)}

<li><p><span className="validation">*</span>Class</p>
	  <p>
	  <FormControl fullWidth  size="small">
       
        <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.classlabel, value: this.state.classid }}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.classid}
		  name="classid"
		
		
        >
		{this.state.Classarr.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>
	  
	  </li>	


<li><p><span className="validation">*</span>Batch</p>
	  <p>
	  <FormControl  fullWidth size="small" >
       
        <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.batchlabel, value: this.state.batchid }}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.batchid}
		  name="batchid"
		
		
        >
		{this.state.Batcharr.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>
	  
	  </li>	  



 <li>
                <p className="searchbutton">
                  <Button variant="contained" onClick={this.handleClickSearch} endIcon={<SearchIcon />}>
                    Search
                  </Button>
                </p>
              </li>


</ul>


</div>





<div className="topperlistcontainer">
  <ul>
    {this.state.ToppersData.map((item, index) => (
      <li key={index}>
        <div className="topperdetails">
          <h3>{item.student_name.charAt(0).toUpperCase() + item.student_name.slice(1)}</h3>
          <p><b>{item.tc_title}</b></p>
          <p>Marks - {item.total_obtained}</p>
        </div>
      </li>
    ))}
  </ul>

  {this.state.ToppersData.length === 0 && (
    <p style={{ textAlign: 'center' }}>No Records Found</p>
  )}
</div>


</div>




<Teacherclasswisecomparisionreport />

  </React.Fragment>
   
		);
		
		
	}
	
	
}

